module.exports = __webpack_public_path__ + "img/friendly-restaurant.25dfeed2.jpg";